exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-space{padding-left:35px}.gap-3{gap:15px 30px}.flex-row .transDropdown{width:auto;flex-grow:1}.grid-template{grid-template-columns:repeat(auto-fit,minmax(250px,1fr));display:grid;grid-column-gap:30px;grid-row-gap:10px;margin-bottom:15px}.grid-template .transDropdown{width:100%}.card-tools{text-align:center;width:100%}.page-select{width:110px}", ""]);

// exports
